<template>
    <base-control :constraints="constraints"
                  :errorMsg="(!available && guestCustomerWantsToRegister) ? alreadyExistsError: null"
                  :rightIcon="['far', 'at']"
                  :state="emailState"
                  :triggerValidation="guestCustomerValidationTriggered"
                  @focusout="onEmailFocusout"
                  @validated="onEmailValidated"
                  class="vc-checkout-user__email"
                  :id="formFieldsIds.guestCustomerEmail"
                  key="checkout-user-email"
                  label="Email"
                  name="email"
                  ref="emailControl"
                  tabindex="2"
                  type="email"
                  v-model="email"></base-control>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Login from '../../mixins/login.vue'

    export default {
        name: "checkout-customer-email",
        data() {
            return {
                email: null,
                lastChecked: null,
                checkingInProgress: false,
                checkingCounter: 0,
                maxCheckingAttempt: 7,
                validated: false,
                available: true,
                alreadyExistsError: 'This email address is already taken. If you own this account, please login',
                constraints: {
                    presence: {
                        allowEmpty: false,
                        message: 'Please enter your email.'
                    },
                    email: {
                        message: 'Please enter a valid email.'
                    },
                },
            }
        },
        mixins: [Login],
        computed: {
            emailState() {
                if (this.checkingInProgress)
                    return 'processing';
                else if (!this.available && this.guestCustomerWantsToRegister)
                    return 'error';
                else
                    return 'info'
            },
            guestTemporaryPasswordNotification() {
                return this.email && this.email === this.lastChecked && this.guestCustomerWantsToRegister && this.available;
            },
            ...mapGetters('checkout', [
                'guestCustomerValidationTriggered',
                'guestCustomerWantsToRegister',
                'formFieldsIds'
            ]),
        },
        watch: {
            email(value) {
                this.$store.commit('checkout/guestCustomerEmail', value);
            },
            guestCustomerWantsToRegister(value) {
                this.checkIfEmailIsAvailable();
            },
            guestTemporaryPasswordNotification(value) {
                this.$store.commit('checkout/guestTemporaryPasswordNotification', value);
            }
        },
        methods: {
            checkIfEmailIsAvailable() {
                if (!this.guestCustomerWantsToRegister || !this.validated || this.checkingInProgress || this.email === this.lastChecked || ++this.checkingCounter > this.maxCheckingAttempt)
                    return;

                this.checkingInProgress = true;
                this.checkIfEmailAvailable(this.email)
                    .then((response) => {
                        this.lastChecked = this.email;
                        this.available = response.data;
                    })
                    .finally(() => {
                        this.checkingInProgress = false;
                    })
            },
            onEmailFocusout() {
                this.checkIfEmailIsAvailable('focusout');
            },
            onEmailValidated(validated) {
                this.validated = validated;
                this.$store.commit('checkout/guestCustomerEmailValidated', validated);
            },
        }
    }
</script>

<style scoped>

</style>